var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"banner-img",attrs:{"src":this.$route.query.targetUrl,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }